import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { ActionCreators } from "redux-undo";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import { Content } from "./Content";

export const CommonEdit = ({
  text, onSave = () => { }, oncancel = () => { }, children,
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(ActionCreators.clearHistory());
  }, [dispatch]);

  const nPast = useAppSelector((state) => state.task.past.length);
  const canRedo = useAppSelector((state) => state.task.future.length > 0);
  function cancelHandle() {
    dispatch(ActionCreators.jumpToPast(0));
    oncancel();
  }

  const title = (
    <Stack direction={"row"} alignItems={"center"}>
      <Typography variant="h5">
        {text}
      </Typography>
      <IconButton
        disabled={nPast === 0}
        color="primary"
        onClick={() => dispatch(ActionCreators.undo())}
      >
        <UndoIcon />
      </IconButton>
      <IconButton
        disabled={!canRedo}
        color="primary"
        onClick={() => dispatch(ActionCreators.redo())}
      >
        <RedoIcon />
      </IconButton>
    </Stack>
  );
  const footer = (
    <Stack spacing={2} direction="row">
      <Button variant="contained" onClick={onSave}>
        Save
      </Button>
      <Button variant="contained" onClick={cancelHandle}>
        Back
      </Button>
    </Stack>
  );
  return (
    <Content title={title} footer={footer}>
      {children}
    </Content>
  );
};
